import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=7d945dc8&scoped=true&"
import script from "./SimpleButton.vue?vue&type=script&lang=js&"
export * from "./SimpleButton.vue?vue&type=script&lang=js&"
import style0 from "./SimpleButton.vue?vue&type=style&index=0&id=7d945dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d945dc8",
  null
  
)

export default component.exports